var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCzech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagCzech_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagCzech_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagCzech_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagCzech_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagCzech_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C40028",
    d: "M-4 44.114h70.482V2.998H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-4 23.553h70.482V2.998H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29457C",
    d: "M-4 2.999v41.116l30.836-20.563z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0id3JncG0yZzloYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSIxcHA0Zmg2OGRiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3dyZ3BtMmc5aGEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiN3cmdwbTJnOWhhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjMXBwNGZoNjhkYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0M0MDAyOCIgZD0iTTAgNDEuMTE0TDcwLjQ4MiA0MS4xMTQgNzAuNDgyIC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00IDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTAgMjAuNTUzTDcwLjQ4MiAyMC41NTMgNzAuNDgyIC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00IDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzI5NDU3QyIgZD0iTTAgLTAuMDAxTDAgNDEuMTE1IDMwLjgzNiAyMC41NTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNCAzKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagCzech as ReactComponent };